import { Component } from 'react';

// Zachytí runtime chyby v podstromu a místo bílé obrazovky ukáže čitelnou hlášku
// s možností obnovy. Zobrazí i text chyby, aby šlo problém nahlásit/odladit.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Necháme v konzoli pro diagnostiku.
    console.error('Zachycená chyba v UI:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{ maxWidth: 560, margin: '60px auto', padding: '0 20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
        <h2 style={{ marginBottom: 8 }}>Něco se pokazilo</h2>
        <p style={{ color: '#666', marginBottom: 20 }}>
          Stránku se nepodařilo zobrazit. Zkuste ji načíst znovu.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 24 }}>
          <button
            onClick={() => { window.location.href = '/'; }}
            style={{ background: '#c0392b', color: 'white', border: 0, borderRadius: 6, padding: '10px 18px', cursor: 'pointer', fontSize: '0.95rem' }}>
            Zpět na úvod
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{ background: 'transparent', color: '#c0392b', border: '1px solid #c0392b', borderRadius: 6, padding: '10px 18px', cursor: 'pointer', fontSize: '0.95rem' }}>
            Načíst znovu
          </button>
        </div>
        {(this.state.error?.name || this.state.error?.message) && (
          <p style={{ color: '#a33', fontWeight: 600, marginBottom: 16, wordBreak: 'break-word' }}>
            {[this.state.error?.name, this.state.error?.message].filter(Boolean).join(': ')}
          </p>
        )}
        <details style={{ textAlign: 'left', background: 'rgba(0,0,0,0.04)', borderRadius: 6, padding: 12 }}>
          <summary style={{ cursor: 'pointer', color: '#888', fontSize: '0.8rem' }}>Technické detaily</summary>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '0.75rem', color: '#a33', marginTop: 8 }}>
            {[
              [this.state.error?.name, this.state.error?.message].filter(Boolean).join(': '),
              this.state.error?.stack,
            ].filter(Boolean).join('\n\n') || String(this.state.error)}
          </pre>
        </details>
      </div>
    );
  }
}
